import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import { token } from "functions/Helper";
import CreateMerchantOnlineProductCost from "views/MerchantOnlineProductCost/Create";
import DeleteMerchantOnlineProductCost from "views/MerchantOnlineProductCost/Delete";
import EditMerchantOnlineProductCost from "views/MerchantOnlineProductCost/Edit";
import MerchantOnlineProductCost from "views/MerchantOnlineProductCost/List";

const merchantOnlineProductCost = () => {
  let views = [];

  if (
    token["travelagent.product_costs.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantOnlineProductCost/List",
      name: "M Online Product Cost",
      icon: MonetizationOnIcon,
      component: MerchantOnlineProductCost,
      layout: "/admin"
    });
  }

  return views;
};

const merchantOnlineProductCostHidden = () => {
  let views = [];

  if (
    token["travelagent.product_costs.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/MerchantOnlineProductCost/Create",
        name: "Create M Online Product Cost",
        component: CreateMerchantOnlineProductCost,
        layout: "/admin"
      },
      {
        path: "/MerchantOnlineProductCost/Edit",
        name: "Edit M Online Product Cost",
        component: EditMerchantOnlineProductCost,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantOnlineProductCost/Delete",
        name: "Delete M Online Product Cost",
        component: DeleteMerchantOnlineProductCost,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  return [
    {
      collapse: true,
      name: "Merchant Online Product Cost",
      state: "merchantOnlineProductCost",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { merchantOnlineProductCost, merchantOnlineProductCostHidden };
